export default __webpack_public_path__ + "static/media/icone-configuracoes.603c8619.svg";